module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"feedback":{"message":"Not seeing something you wish to automate?","tellUs":"Let us know!"}}}')
  delete Component.options._Ctor
}
